var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeadPopups(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 74,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lead-popups_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.135 45.35s-.475 15.694-10.337 18.922c-11.4 2.503-17.096 13.561-38.932 8.656C13.03 68.024 12.179 61.986 6.179 57.675-6.063 48.878 1.99 5.833 15.526 4.053 29.064 2.34 68.127-6.848 79.335 10.73c7.91 9.744 4.8 34.622 4.8 34.622z",
    fill: "#E7EBF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.733 53.327h-53.56c-.939 0-1.743-.803-1.743-1.74V19.74c0-.937.804-1.74 1.743-1.74h53.56c.939 0 1.743.803 1.743 1.74v31.915c0 .936-.737 1.672-1.743 1.672z",
    fill: "#fff",
    stroke: "#919BBB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.326 20.743H16.11v29.774h51.215V20.743z",
    fill: "#fff",
    stroke: "#919BBB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7EBF3",
    d: "M17 21h50v29H17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CED3DC",
    d: "M19.4 23.65h22.1v1.275H19.4zm22.1 2.55H30.45v1.275H41.5zm-22.1 5.1h22.1v1.275H19.4zm0-2.55h12.75v1.275H19.4zm14.025 0H41.5v1.275h-8.075zm-2.975 5.1H19.4v1.275h11.05zm-1.275-7.65H19.4v1.275h9.775zM41.5 36.4H30.45v1.275H41.5zm-22.1 5.1h22.1v1.275H19.4zm0-2.55h12.75v1.275H19.4zm14.025 0H41.5v1.275h-8.075zM19.4 46.6h8.075v1.275H19.4zm22.1-2.55H19.4v1.275h22.1zM29.175 36.4H19.4v1.275h9.775z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 22,
    width: 21,
    height: 25,
    rx: 1,
    fill: "#8FDEA3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 43,
    width: 17,
    height: 3,
    rx: 1.5,
    fill: "#6F87FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.725 44.05h8.925v.85h-8.925z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 24,
    width: 17,
    height: 11,
    rx: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7EBF3",
    d: "M46.47 24.758l15.101 8.778-.218.302-15.102-8.777z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7EBF3",
    d: "M46.321 33.636l14.957-8.975.223.299-14.957 8.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.875 24.925h11.05v8.5h-11.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.25 26.125h-6.5c-.414 0-.75.378-.75.844v5.062c0 .466.336.844.75.844h6.5c.414 0 .75-.378.75-.844V26.97c0-.466-.336-.844-.75-.844zm.25 5.906c0 .155-.112.282-.25.282h-6.5c-.138 0-.25-.127-.25-.282V26.97c0-.155.112-.282.25-.282h6.5c.138 0 .25.127.25.282v5.062zm-5.75-2.953c.483 0 .875-.44.875-.984s-.392-.985-.875-.985-.875.441-.875.985c0 .543.392.984.875.984zm0-1.406c.207 0 .375.19.375.422 0 .232-.168.422-.375.422s-.375-.19-.375-.422c0-.233.168-.422.375-.422zm3.235.405l-1.485 1.67-.485-.545a.346.346 0 00-.53 0l-1.375 1.547a.43.43 0 00-.081.136.47.47 0 00-.029.162v.492c0 .117.084.211.188.211h5.624c.104 0 .188-.094.188-.21v-1.618a.45.45 0 00-.11-.298l-1.375-1.547a.346.346 0 00-.53 0zm1.515 3.11h-5v-.082l1.25-1.406.75.844 1.75-1.97 1.25 1.407v1.207z",
    fill: "#E7EBF3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#529763",
    d: "M48 36h11v2H48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.75 38.95h14.875v.85H45.75zm0 1.7h14.875v.85H45.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.107 52.458c0 .87-.402 1.672-1.005 2.274-.604.602-1.475.937-2.413.937h-61.27C9.542 55.669 8 54.197 8 52.458v-.402h68.04c.067.134.067.268.067.402z",
    fill: "#fff",
    stroke: "#919BBB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.494 52.056h-15.15v.87h15.15v-.87z",
    fill: "#fff",
    stroke: "#919BBB",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lead-popups_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h85v74H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/lead-popups.77ee75c4eba076edbe045ef875fd0030.svg";
export { SvgLeadPopups as ReactComponent };